import React from 'react';
import Title from '../../title';
import { Card, Dropdown } from 'semantic-ui-react';
import Loading from '../../loading';
import $ from "jquery";
import Server from '../../../functions/server';
import Stock from './stocktransfer';
import ReadCookie from '../../../functions/readcookies';
import Permission from '../../../functions/permission';

class StockTransfer extends React.Component {

  state = {
    load: false,
    message: '', menuPermission: []
  }

  componentDidMount() {
    this.getMenucontrol();
    this.getBranch();
    this.getBranch1();
  }

  getMenucontrol() {
    let menuPermission = Permission('stock-transfer', this.props.menus);
    this.setState({ menuPermission })
  }


  getBranch() {
    let data = (ReadCookie("branch"));
    if (data == 0) {
      this.setState({ permissionError: 'You not have permission to access this menu!!!' })
    }
    else {
      let branchId;
      for (var i = 0; i < data.length; i++) {
        branchId = data[i].branch_id;
      }
      this.setState({ selectedBranch: branchId })
    }
  }

  getBranch1() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Branchs'
    })
    $.ajax({
      type: 'POST',
      url: Server() + 'branchdetails/getallbranchs.php',
      success: function(data)
      {
        try {
          data = JSON.parse(data);
          context.setAllBranch(data);
          for (var i = 0; i < data.length; i++) {
            let s = 1;
            data[i].sino = s + i;
          }
          context.setState({
            load: false,
            allbranch: data
          });
        } catch (e) {
          context.setState({
            load: false,
          });
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  setAllBranch(data) {
    let context = this;
    var x = [];
    data.map((y) => {
      x.push({key: y.name, text: y.name, value: y.id});
    });
    try {
      context.setState({
        branchOptions: x,
      });
    } catch (e) {

    }
  }

  branch = (f, { value }) => {
    this.setState({ selectedBranch: value })
  }

  render() {
    return (
      <div>
          <Title title={'Stock Transfer'} openDrawer={this.props.openDrawer} />
        { this.state.menuPermission.view ?
          (
            <div>
              <Loading load={this.state.load} message={this.state.message} />
              <center style={{color: 'red'}}><b>{this.state.permissionError}</b></center>
              <div>
                <b style={{display: 'none'}}>Select Branch<br/></b>
                <Dropdown placeholder='Customer Type' style={{ borderColor: '#5A9CBB', display: 'none' }}
                 fluid search selection onChange={this.branch}
                 options={this.state.branchOptions} value={this.state.selectedBranch} />
                { this.state.selectedBranch ?
                  (
                    <div>
                    <Stock branchOptions={this.state.allbranch} selectedBranch={this.state.selectedBranch}
                      menus={this.props.menus} stockinview={this.state.stockinview}
                      menuPermission={this.state.menuPermission}
                      stockinedit={this.state.stockinedit} stocktransferedit={this.state.stocktransferedit}
                      stockoutview={this.state.stockoutview} stockoutedit={this.state.stockoutedit}
                      shortageview={this.state.shortageview} shortageedit={this.state.shortageedit} /></div>
                  ) :
                  (
                    <div></div>
                  )
                }
              </div>
            </div>
          ):
          (
            <div>
              <center>You are not allow to access this menu!!!</center>
            </div>
          )
        }
      </div>
    );
  }
}

export default StockTransfer;
